import { useState, type ReactNode } from "react";
import { createPortal } from "react-dom";
import { X } from "lucide-react";
import clsx from "clsx";

type ExpandCollapseProps = {
  title: ReactNode;
  children: ReactNode;
  portalId: string;
};

const ExpandCollapse: React.FC<ExpandCollapseProps> = ({ title, children, portalId }) => {
  const [isOpen, setIsOpen] = useState(false);

  const Panel = (
    <div
      className={clsx(
        "overflow-hidden transition-all duration-500 ease-in-out bg-white border-b shadow-md w-full",
        isOpen ? "max-h-[700px] opacity-100" : "max-h-0 opacity-0"
      )}
    >
      <div className="relative p-6">
        <button
          onClick={() => setIsOpen(false)}
          className="absolute top-2 right-2 text-gray-500 hover:text-gray-700"
        >
          <X className="w-5 h-5" />
        </button>
        {children}
      </div>
    </div>
  );

  return (
    <>
      {/* ปุ่ม trigger อยู่ตรงไหนก็ได้ */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="px-4 py-2 text-sm text-gray-700 hover:text-black"
      >
        {title}
      </button>

      {/* Render panel */}
      {portalId && typeof document !== "undefined" ?
        document.getElementById(portalId) ?
          createPortal(Panel, document.getElementById(portalId)!)
        : null
      : Panel}
    </>
  );
};

export default ExpandCollapse;
